import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';

export const requestGetUnreadMessages = async(pageNumber: number, pageSize: number) => {
    const url = `/${SERVICES.CONTACT}/phone-chats/unread`;
    const requestData = {
        pageNumber,
        pageSize
    };
    try {
        const response = await axios.post(url, requestData);
        return response?.data;
    }
    catch (err) {
        Notistack.generalError(getError(err));
    }
};

export const markAsRead = async(messagesIds: string[]) => {
    const url = `/${SERVICES.CONTACT}/phone-chats/read`;
    try {
        const response = await axios.post(url, messagesIds);
        return response?.data;
    }
    catch (err) {
        Notistack.generalError(getError(err));
    }
};